"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _InvitationTypesList = _interopRequireDefault(require("../../components/InvitationTypesList/InvitationTypesList"));

var _gift = require("../../store/gift/gift.selector");

var _useSetDefaultInvitationTypeEffect = require("../../../hooks/useSetDefaultInvitationTypeEffect");

var _InvitationTypeAddressForm = _interopRequireDefault(require("../../components/InvitationAddressForm/InvitationTypeAddressForm"));

var _invitationType = require("../../store/gift/invitationType/invitationType.selectors");

var _invitationType2 = require("../../store/gift/invitationType/invitationType.actions");

var _features = require("../../../Shared/store/features");

var _ProductDetails = _interopRequireDefault(require("../../components/ProductDetails/ProductDetails"));

var _gift2 = require("../../store/gift/gift.actions");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    header: {
      padding: spacing(3),
      paddingRight: spacing(2),
      paddingLeft: spacing(6)
    },
    loaderWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: spacing(8)
    }
  };
});

var SelectInvitationType = function SelectInvitationType() {
  var classes = useStyles();

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var dispatch = (0, _reactRedux.useDispatch)();
  var isLoading = (0, _reactRedux.useSelector)(_invitationType.getIsInvitationTypesLoading);
  var giftId = (0, _reactRedux.useSelector)(_gift.getGiftId);
  var isDirectMailEnabled = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(_features.Features.FLAGS.DIRECT_MAIL));
  var title = "How do you want to send this ".concat(isDirectMailEnabled ? 'gift' : 'invite', "?");
  var invitationErrors = (0, _reactRedux.useSelector)(_invitationType.getInvitationTypeErrors);
  var product = (0, _reactRedux.useSelector)(_gift.getGiftProduct);
  (0, _useSetDefaultInvitationTypeEffect.useSetDefaultInvitationTypeEffect)();
  (0, _react.useEffect)(function () {
    dispatch((0, _invitationType2.getInvitationTypes)());
    setIsOpen(true);
  }, [dispatch, giftId]);
  var handleAcceptDetailsProduct = (0, _react.useCallback)(function (_, optionsValues) {
    dispatch((0, _gift2.setGiftProductOptions)(optionsValues));
    dispatch((0, _invitationType2.clearError)(['options']));
    setIsOpen(true);
  }, [dispatch]);
  var handleSetMethod = (0, _react.useCallback)(function () {
    setIsOpen(true);
  }, []);
  var handleCloseViewProductDetails = (0, _react.useCallback)(function () {
    setIsOpen(false);
    dispatch((0, _invitationType2.clearError)(['options']));
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column",
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "H4-Chambray",
    "data-testid": "SelectInvitationType.Header"
  }, title)), isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.loaderWrapper
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null)) : /*#__PURE__*/_react.default.createElement(_InvitationTypesList.default, null), /*#__PURE__*/_react.default.createElement(_InvitationTypeAddressForm.default, {
    onClick: handleSetMethod
  }), isDirectMailEnabled && Boolean(invitationErrors.options) && /*#__PURE__*/_react.default.createElement(_ProductDetails.default, {
    isOpen: isOpen,
    product: product,
    onClose: handleCloseViewProductDetails,
    onSubmit: handleAcceptDetailsProduct
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(SelectInvitationType);

exports.default = _default;